import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import color from "../../Constants/colors";
import AmbassadorThemeProvider from "./Common/AmbassadorThemeProvider";
import { useAmbassadorHomePath } from "./Common/ambassadorNavigation";

/** Frame of every Ambassador Workspace page: the light module theme. The
 * module's pages are entries of the main sidebar (navigationItems.tsx). */
const AmbassadorLayout: React.FC = () => (
  <AmbassadorThemeProvider>
    <Box sx={{ minHeight: "100%", backgroundColor: color.gray50 }}>
      <Box
        sx={{
          maxWidth: 1440,
          mx: "auto",
          px: { xs: 2, md: 3 },
          py: { xs: 2, md: 3 },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  </AmbassadorThemeProvider>
);

export const AmbassadorIndex: React.FC = () => (
  <Navigate to={useAmbassadorHomePath()} replace />
);

export default AmbassadorLayout;
